import * as React from 'react';
import { get, map } from 'lodash';
import { TAppointment } from 'ui-model';
import { useCurrentMaster } from '@lib/hooks';
import getActionsSetting from 'modules/LumaBotV2/components/Rescheduler/getActionsSetting';
import AppointmentsListContainer from '../AppointmentsListContainer';
import AppointmentItem from '../AppointmentItem';

interface IAppointmentsListData {
  data: TAppointment[];
}

const AppointmentsListData = (props: IAppointmentsListData) => {
  const { data } = props;
  const [selectedAppointment, setSelectedAppointment] = React.useState<TAppointment>(data[0]);
  const currentMaster = useCurrentMaster();
  return (
    <AppointmentsListContainer>
      {map(data, (appointment) => {
        const isAppointmentSelected = appointment._id === get(selectedAppointment, '_id');
        const { cancelAllowed, rescheduleAllowed } = getActionsSetting(appointment, currentMaster?.settings);

        return (
          <AppointmentItem.Container
            id={appointment._id}
            isAppointmentSelected={isAppointmentSelected}
            isRescheduleEnabled={rescheduleAllowed}
            isCancelEnabled={cancelAllowed}
            onClick={() => setSelectedAppointment(appointment)}
          >
            <AppointmentItem.Header
              appointmentDate={appointment.date}
              appointmentTypeName={appointment.type.name || '...'}
              isAppointmentSelected={isAppointmentSelected}
            />
            <AppointmentItem.Collapsable isAppointmentSelected={isAppointmentSelected}>
              <AppointmentItem.Divider />
              <AppointmentItem.Content appointment={appointment} />
              <AppointmentItem.ActionButtons
                appointment={appointment}
                isRescheduleEnabled={rescheduleAllowed}
                isCancelEnabled={cancelAllowed}
              />
            </AppointmentItem.Collapsable>
          </AppointmentItem.Container>
        );
      })}
    </AppointmentsListContainer>
  );
};

export default AppointmentsListData;
